import { RouteConfig } from 'vue-router'
import common from './common.ts'
import equipment from './equipment.ts'

const Baseline = () => import('@/nms/layouts/baseline.vue')

const routes: RouteConfig[] = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/login',
    name: 'login',
    props: true,
    component: () => import('@/nms/pages/auth/auth.vue'),
  },
  {
    path: '/common',
    meta: {
      name: 'common',
    },
    component: Baseline,
    children: [
      ...common,
      ...equipment,
    ],
  },
]

export default routes